module.exports = __webpack_public_path__ + "static/media/ic_recorded.87492d93.svg";